import { faClose } from '@fortawesome/pro-light-svg-icons'
import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslations } from 'next-intl'
import {
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuTrigger,
} from '@radix-ui/react-navigation-menu'
import { SolidButton } from '@repo/complib/SolidButton'

export const ContactMenu = ({
  closeFn,
  locale,
}: {
  closeFn?: () => void
  locale: string
}) => {
  const t = useTranslations('Navigation.ContactMenu')

  return (
    <div
      className='font-manrope text-text-800 min-h-[100dvh] md:min-h-fit lg:w-[350px]'
      data-testid='contact-menu'
    >
      <div className='bg-surface-tealgrey-50 text-body-md-bold xs:hidden flex items-center justify-between p-4'>
        {t('label')}
        {closeFn ? (
          <button onClick={closeFn} type='button'>
            <FontAwesomeIcon icon={faClose} size='2x' />
            <span className='sr-only'>{t('close')}</span>
          </button>
        ) : (
          // case for mobile sub menu
          <NavigationMenuItem>
            <NavigationMenuTrigger>
              <FontAwesomeIcon icon={faClose} size='2x' />
              <span className='sr-only'>{t('close')}</span>
            </NavigationMenuTrigger>
          </NavigationMenuItem>
        )}
      </div>
      <div className='flex flex-col gap-8 p-4'>
        <div className='flex flex-col gap-6'>
          <p className='text-body-sm text-text-500'>{t('kicker')}</p>
          <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-2'>
              <div className='text-body-md-bold'>{t('service.headline')}</div>
              <p className='text-body-sm'>{t('service.text')}</p>
            </div>
            <div className='flex flex-col gap-2'>
              {locale !== 'es' && (
                <SolidButton
                  asChild
                  className='!text-body-md-bold !justify-start !gap-2 !px-0 !py-0'
                  elevated={false}
                  variant='textlink'
                >
                  <NavigationMenuLink href={t('service.button.phone.href')}>
                    <FontAwesomeIcon icon={faPhone} />
                    <span>{t('service.button.phone.switchText')}</span>
                  </NavigationMenuLink>
                </SolidButton>
              )}
              <SolidButton
                asChild
                className='!text-body-md-bold !justify-start !gap-2 !px-0 !py-0'
                elevated={false}
                variant='textlink'
              >
                <NavigationMenuLink href={t('service.button.email.href')}>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>{t('service.button.email.switchText')}</span>
                </NavigationMenuLink>
              </SolidButton>
            </div>
          </div>
        </div>
        {locale !== 'es' && (
          <div className='bg-surface-tealgrey-50 flex flex-col gap-4 rounded-md p-3'>
            <div className='text-body-md-bold'>{t('booking.headline')}</div>
            <SolidButton
              asChild
              className='!text-body-md-bold !justify-start !gap-2 !px-0 !py-0'
              elevated={false}
              variant='textlink'
            >
              <NavigationMenuLink href={t('service.button.phone.href')}>
                <FontAwesomeIcon icon={faPhone} />
                <span>{t('service.button.phone.switchText')}</span>
              </NavigationMenuLink>
            </SolidButton>
          </div>
        )}
      </div>
    </div>
  )
}
